// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__25HFm","colMin":"styles_colMin__1M5CT","colCheckbox":"styles_colCheckbox__KAtKS"};